export default "__VITE_ASSET__C50yDauU__"